(function() { module.exports = window["novablocks"]["doppler/frontend"]; }());